<template>
<div style="position: relative;">
    <div :class="$style.selectUser">
        <button @click="add_user" style="position:absolute;top:-10px;left:0px;">{{ 'new_user' | str}}</button>
        <input type="text" v-model="user_search" :placeholder="label('search_users')">
        <select v-model="user_record" size="30">
            <option selected disabled/>
            <option v-for="user in filtered_users" :key="user.id" :value="user">
                {{user.username}}
            </option>
        </select>
    </div>

    <div :class="$style.main">
        <template v-if="user">
            <transition name='fade'>
            <button v-if="valid_user" @click="saveUser" class="themed" style="position:absolute;padding: 5px 10px; top:5px; right:0px;">
                <i class="fa fa-save"></i> 
                {{'save'|str}}
            </button>
            </transition>

            <div :class="$style.formItem">
                <div :class="$style.main_label">{{'username' | str}}:</div> 
                <input  v-if="new_user" type="text" v-model="user.username">
                <template v-else>
                    {{user.username}} 
                </template>

            </div>
            
            <div :class="$style.formItem">
                <div :class="$style.main_label">{{ 'dealerCode' | str}}:</div>

                {{user.dealerCode ? user.dealerCode : 'N/A'}}

                <!--
                <input  v-if="new_user" type="text" v-model="user.dealerCode">
                <template v-else>
                     {{user.dealerCode}}
                </template>
                --> 
                <!-- 
                <select v-if="new_user" v-model="user.dealerCode">
                    <option v-for="item in list_dealerCodes" :key="item" :value="item">
                        {{item}}
                    </option>
                </select> -->
            </div>
            
            <!-- USER TYPE -->
            <div :class="$style.formItem">
                <div :class="$style.main_label"> {{ 'usertype' | str}} :</div>
                <select v-model="user.user_type">
                    <option v-for="item in list_user_types" :key="item.user_type" :value="item.user_type">
                        {{label(item.user_type)}}
                    </option>
                </select>
            </div>
            
            <!-- BRAND -->
            <div :class="$style.formItem">
                <div :class="$style.main_label">{{'brand'|str}}</div>

                <template v-for="brand in list_brands">
                    <label :key="'brand_'+brand.id" :class="['box_radio', {'primary':user.brand && user.brand.id===brand.id}]" v-if="allow_brand_admin || user.brand.id==brand.id">
                        <input type="radio" :value="brand" v-model="user.brand" :disabled="allow_brand_admin===false">
                        {{brand.name}}
                    </label>
                </template>
            </div>

            <div :class="$style.grant_access_container">
                <!-- GROUP ACCESS -->
                <fieldset>
                    <legend :class="$style.section_label">
                        {{ 'reportGroups' | str }} {{user.report_access_roles.length}}/{{list_report_access_roles.length}}
                        <div :class="$style.selectAll"> <label>{{'select_all' | str}}: <input type='checkbox' v-model="check_all.groups" @change="toggle_check_all('groups')"></label></div>
                    </legend>
                    <div :class="$style.checkbox_container">
                    <ul>
                        <template v-for="record in list_report_access_roles">
                            <li :key="'role_'+record.id">
                                <label>
                                    <input type='checkbox' v-model='user.report_access_roles' :value="record">
                                    {{objLabel(record,'name')}}
                                </label>
                            </li>
                        </template>
                    </ul>
                    </div>                
                </fieldset>

                <!-- REPORT ACCESS -->
                <fieldset>
                    <legend :class="$style.section_label">
                        {{ 'reports' |str }} {{report_access.length}}/{{list_reports_access.length}}
                        <div :class="$style.selectAll"> <label>{{'select_all' | str}}: <input type='checkbox' v-model="check_all.reports" @change="toggle_check_all('reports')"></label></div>
                    </legend>
                    <div :class="$style.checkbox_container">
                    <ul>
                        <template v-for="record in list_reports_access">
                            <li :key="'report_'+record.id">
                                <label>
                                    <div style="width: 100%;position:relative;">
                                    <input type='checkbox' v-model='report_access' :value="record.id">
                                        <div :class="$style.report_name">
                                            {{objLabel(record,'name')}}
                                        </div>  
                                    
                                        <div :class="$style.report_code"> {{record.code}} </div>
                                    </div>
                                </label>
                            </li>
                        </template>
                    </ul>
                    </div>
                </fieldset>

                <!-- ZONE ACCESS -->
                <fieldset v-if="show_zones">
                    <legend :class="$style.section_label">
                        {{label('zones')}}
                        <div :class="$style.selectAll"> <label>{{'select_all' | str}}: <input type='checkbox' v-model="check_all.zones" @change="toggle_check_all('zones')"></label></div>
                    </legend>
                    <div :class="$style.checkbox_container">
                    <ul>
                        <template v-for="record in list_zones">
                            <li :key="'report_'+record.id">
                                <label>
                                    <input type='checkbox' v-model='user.zones' :value="record">
                                    {{objLabel(record,'name')}}
                                </label>
                            </li>
                        </template>
                    </ul>
                    </div>
                </fieldset>
            </div>

            <div :class="$style.report_access_list">
                <div :class="$style.section_label">{{label('access_to')}}:</div>
                <ul>
                    <li v-for="report in granted_reports" :key="'granted_'+report.id">
                        <div style="width: 100%;position:relative;">
                            <div :class="$style.report_name">
                                {{objLabel(report,'name')}}
                            </div>                              
                            
                        
                            <div :class="$style.report_code"> {{report.code}} </div>
                        </div>
                    </li>
                </ul>
            </div>

        </template>
    </div>

</div>
</template>

<script>
export default {
    name: 'userAdmin',
    props: {
        adminData: {
            type: Object,
            required: true
        }
    },
    mounted: function(){
        this.init();
    },
    data: function(){
        return {
            new_user: false,
            user_search: null,
            user_record: null,
            report_access: [],
            user: null,
            filtered_users: [],
            timer: null,
            check_all: {
                groups: false,
                reports: false,
                zones: false
            }
        }
    },
    methods: {
        init: function(){
            this.filterUsers();
        },
        add_user: function(){
            var dealerCode = null;
            if(this.$application.getUserType()=='dealerAdmin') {
                dealerCode = this.$application.getDealerCode();
            }
            console.log('new_user');
            var self = this;
            this.report_access = [];
            this.new_user = true;
            this.user = template(dealerCode);
            this.user_record = null;
            this.user_search = null;

            function template(dealerCode){
                return {
                    language: self.$Localization.getLanguage(),
                    dealerCode: dealerCode,
                    brand: {},
                    zones: [],
                    report_access_roles: [],
                    report_metadata: [],

                }
            }
        },
        saveUser: function(){
            console.log('save',this.user);
            var self = this;
            this.save_report_metadata();
            if(this.new_user) {
                self.$api.createUser(self.user).then((userInfo)=>{
                    if(userInfo) {
                        self.user = userInfo;
                        self.$emit('update_pool',self.user,"user", "create");
                        this.new_user = false;
                    }
                });
            }
            else {
                self.$api.updateUserInfo(self.user).then((response)=>{
                    if(response) {
                        // console.log("USER HAS BEEN SAVED",response)
                        self.$emit('update_pool',self.user, "user", "update");
                    }
                });
            }
        },
        objLabel: function(obj,key){
            return this.$Localization.objStr(obj,key);
        },
        label: function(key){
            return this.$Localization.str(key);
        },
        in_array: function(needle,haystack){
            var found = false;
            for(let i in haystack){
                if(haystack[i]==needle){
                    found = true;
                    break;
                }
            }
            return found;
        },
        compare: function(a, b) {
            var nameA
            var nameB
            // Use toUpperCase() to ignore character casing
            switch(this.language){
                default:
                    nameA = a.name.toUpperCase();
                    nameB = b.name.toUpperCase();
                break;

                case"fr":
                    nameA = a.name_fr.toUpperCase();
                    nameB = b.name_fr.toUpperCase();
                break;
            }


            let comparison = nameA.localeCompare(nameB);
            // if (nameA > nameB) {
            //     comparison = 1;
            // } else if (nameA < nameB) {
            //     comparison = -1;
            // }          
            return comparison;
        },
        filterUsers: function() {
            var self = this;
            clearTimeout(self.timer);
            self.timer = setTimeout(function(){
                var list = [];
                if(self.user_search!=null){
                    for(let i=0; i<self.list_users.length; i++){
                        let user = self.list_users[i];
                        if(user.username!=null && user.username.toLowerCase().includes(self.user_search.toLowerCase())){    
                            list.push(user)
                        }
                    }
                }else{
                    list = self.list_users;
                }
                self.filtered_users = list;
            },100)
        },
        set_report_access: function(){
            var self = this;
            self.report_access = [];
            for(let i=0; i<this.list_report_metadata.length; i++){
                var report = this.list_report_metadata[i];

                for(let r=0; r<this.user.report_metadata.length; r++){
                    var record = this.user.report_metadata[r];
                    if(report.id == record.id){
                        self.report_access.push(report.id);
                        break;
                    }
                }
            }            
        },
        save_report_metadata: function(){
            var report_metadata = [];
            for(let i=0; i<this.report_access.length; i++){
                var report_id = this.report_access[i];
                report_metadata.push(this.map_reports[report_id]);
            }
            this.user.report_metadata = report_metadata;
        },
        toggle_check_all: function(target){
            var toggle;
            switch(target){
                case"groups":
                    toggle = this.check_all[target];
                break;

                case"reports":
                    toggle = this.check_all[target];
                break;

                case"zones":
                    toggle = this.check_all[target];
                break;
            }

            
        
            if(toggle){
                this.select_all(target);
            }else{
                this.select_none(target);
            }
                      
        },        
        select_all: function(target){
            console.log('select_all',target);
            this.select_none(target);
            var list;

            switch(target){
                case"groups":
                    list = this.list_report_access_roles;
                break;

                case"reports":
                    list = this.list_report_metadata;
                break;

                case"zones":
                    list = this.list_zones;
                break;
            }

            for(let i=0; i<list.length; i++){
                var record = list[i];
                switch(target){
                    case"groups":
                        this.user.report_access_roles.push(record);
                    break;

                    case"reports":
                        this.report_access.push(record.id);
                    break;

                    case"zones":
                        this.user.zones.push(record);
                    break;
                }
            }            
        },
        select_none: function(target){
            console.log('select_none',target);
            this.check_all[target];
            switch(target){
                case"groups":
                    this.user.report_access_roles = [];
                break;

                case"reports":
                    this.report_access = [];
                break;

                case"zones":
                    this.user.zones = [];
                break;
            }            
        }
    },
    computed: {
        valid_user: function(){
            if(this.user===null){
                return false;
            }else{
                var user = this.user;
                var testResults = {
                    username: notEmpty(user.username),
                    //dealerCode: notEmpty(user.dealerCode),
                    brand: objectLength(user.brand)>0,
                    user_type: notEmpty(user.user_type),
                }
                // console.log('valid_user',{
                //     testResults: testResults,
                //     allTrue: allTrue(testResults)
                // });
                return allTrue(testResults);
            }

            function notEmpty(value){
                return value!=null && value.length>0;
            }

            function objectLength(obj){
                return Object.keys(obj).length;
            }

            function allTrue(obj){
                for(var key in obj){
                    if(obj[key]!=true){
                        return false;
                    }
                }

                return true;
            }
        },
        list_users: function(){
            return this.adminData.userAdmin.users;
        },
        list_user_types: function(){
            return this.adminData.userAdmin.user_types;
        },
        list_dealerCodes: function(){
            return this.adminData.dealerCodes;
        },
        list_brands: function(){
            return this.adminData.userAdmin.brands;
        },
        list_report_access_roles: function(){
            return this.adminData.userAdmin.report_access_roles;
        },
        list_report_metadata: function(){
            var recordSource = this.adminData.userAdmin.report_metadata;
            var records = [];

            for(let i=0; i<recordSource.length; i++){
                let record=recordSource[i];            
                records.push({
                    code: record.code,
                    id: record.id,
                    name: record.name,
                    name_fr: record.name_fr,
                    brand_id: record.brand_id                   
                })
            }
            return records;
        },
        list_reports_access: function(){          
            var filteredAccess = [];
             //find brand_id for 'ALL'
            var brand_id_all = 3;
            var brandsList = this.list_brands;
            for(let i=0; i<brandsList.length; i++){
                if(brandsList[i].code==='ALL'){
                    brand_id_all = brandsList[i].id;
                    break;
                }
            }
            //Filter by Brand
            var access = this.list_report_metadata;
            for(let i=0; i<access.length; i++){             
                if(this.user.brand.code==='ALL' && access[i].brand_id) {
                    filteredAccess.push(access[i]);
                } else {
                    if(access[i].brand_id===this.user.brand.id || access[i].brand_id===brand_id_all){
                        filteredAccess.push(access[i]);
                    }
                }
            }                        
            return filteredAccess;
        },
        list_zones: function(){
            return this.adminData.userAdmin.zones;
        },
        map_reports: function(){
            var map = {};
            for(let i=0; i<this.list_report_metadata.length; i++){
                var report = this.list_report_metadata[i];
                map[report.id] = report;
            }

            return map;
        },
        granted_reports: function(){
            
            var container = {};
            var access = [];
            var filteredAccess = [];
            var reports;

            var roles = this.user.report_access_roles;
            for(let i=0; i<roles.length; i++){
                reports = roles[i];
                
                for(let r=0; r<reports.report_metadata.length; r++){
                    let report = reports.report_metadata[r];
                    container[report.id] = true;
                }
            }
            
            var meta = this.report_access;
            for(let i=0; i<meta.length; i++){
                let report_id = meta[i];                
                container[report_id] = true;
            }


            reports = this.list_report_metadata;
            for(let i=0; i<reports.length; i++){
                let report = reports[i];
                if(container[report.id]){
                    access.push(report);
                }
            }

            access.sort(this.compare);
            //find brand_id for 'ALL'
            var brand_id_all = 3;
            var brandsList = this.list_brands;
            for(let i=0; i<brandsList.length; i++){
                if(brandsList[i].code==='ALL'){
                    brand_id_all = brandsList[i].id;
                    break;
                }
            }
            //Filter by Brand
            for(let i=0; i<access.length; i++){             
                if(this.user.brand.code==='ALL' && access[i].brand_id) {
                    filteredAccess.push(access[i]);
                } else {
                    if(access[i].brand_id===this.user.brand.id || access[i].brand_id===brand_id_all){
                        filteredAccess.push(access[i]);
                    }
                }
            }            
            return filteredAccess;
        },
        language: function(){
            return this.$Localization.currentLanguage;
        },
        allow_brand_admin: function(){
            return this.$application.allowBrandAdmin();
        },
        show_zones: function(){
            return this.user.user_type=='zoneUser'
        },
        selected_groups: function(){
            var count = this.user ? this.user.report_access_roles.length : 0;
            return count;
        },
        selected_reports: function(){
            var count = this.report_access.length;
            return count;
        },
        selected_zones: function(){
            var count = this.user ? this.user.zones.length : 0;
            return count;
        }
    },
    watch: {
        user_record: function(){
            var self = this;
            if(this.user_record){
                self.$api.getUserUserDetailsForAdmin(this.user_record.id).then(function(response){
                    self.new_user = false;
                    self.user = response;
                    self.set_report_access();
                });
            }
        },
        list_users: {
            deep: true,
            handler: function(){
                console.log('enable save')
            }
        },
        user: function(){
            // this.grant.reports = [];
        },
        user_search: function(){
            this.filterUsers();          
        },
        selected_groups: function(){
            var count = this.selected_groups;
            var max = this.list_report_access_roles.length;
            this.check_all.groups = count==max;      
        },
        selected_reports: function(){
            var count = this.selected_reports;
            var max = this.list_report_metadata.length;
            this.check_all.reports = count==max;
        },
        selected_zones: function(){
            var count = this.selected_zones;
            var max = this.list_zones.length;
            this.check_all.zones = count==max;
        }
    }
}
</script>


<style lang='scss'>
@import "@/_variables.scss";
.box_radio{
    border-radius: 3px;
    padding: 5px;
    display: inline-block;
    margin-right: 5px;
    cursor: pointer;
}

.box_radio:hover{
    text-decoration: underline;
}

.box_radio input{
    display: none;
}

.lexus .themed{
    background-color: $lexus;
}
.lexus label.box_radio {
    border: 1px solid lightslategray;
    background-color: lightslategray;
    color: white;
}
.lexus label.box_radio.primary {
    background-color: $lexus;
    border-color: $lexus;
}



.toyota .themed{
    background-color: $toyota;
}
.toyota label.box_radio {
    border: 1px solid lightslategray;
    background-color: lightslategray;
    color: white;
}
.toyota label.box_radio.primary {
    background-color: $toyota;
    border-color: $toyota;
}
</style>






<style module>
.main_label{
    display: inline-block;
    min-width: 110px;
    font-size: 1em;
    font-weight: bold;    
}
.section_label{
    display: inline-block;
    min-width: 110px;
    font-size: 1em;
    font-weight: bold;     
}

.selectUser{
    position: relative;
    display: inline-block;
    vertical-align: top;
    text-align: left;
    width: 21%;
    min-width: 250px;
    min-height: 200px;
    padding-top: 20px;
    /* border: 1px solid grey; */
}

.selectUser input {
    font-size: 1em;
    margin-bottom: 5px;
    padding: 3px;
    box-sizing: border-box;
}

.selectUser input, .selectUser select{
    /* min-height: 200px; */

    width: 100%;
}

.selectAll{
    position: absolute;
    right: 0px;
    top: -8px;
    background-color: #FDFDFD;
    padding-left: 10px;
    margin-left: 10px;
}

.main{
    position: relative;
    display: inline-block;
    vertical-align: top;
    width: 72%;
    min-height: 400px;
    text-align: left;
    padding: 15px;
}

.main fieldset{
    position: relative;
    padding: 3px;
}

.formItem{
    display: block;
    margin: 10px;
    border-bottom: 1px solid whitesmoke;
    padding-bottom: 3px;
    margin-bottom: 5px;
    font-size: 0.8em;
}

.main ul{
    list-style: none;
    margin-left: 0px;
}

.main ul{
    margin-left: -15px;
}
.main li{
    margin-left: -20px;
    padding-left: 5px;
    border-radius: 2px;
}
.main li:hover{
    text-decoration: underline;
}
    .main li:nth-child(odd){
        background-color: whitesmoke;
    }

.main input[type='checkbox']{
    width: 15px;
    height: 15px;
    margin: 5px;
    transform: translateY(3px);

}


.grant_access_container{
    width:60%;
    display:inline-block;
    vertical-align:top;
}

@media only screen and (max-width: 1024px) {
    .grant_access_container{
        width:100%;
    }
}

.checkbox_container{
    height:300px;
    max-width: 590px;
    border: 1px solid whitesmoke; 
    border-radius: 5px;
    overflow-y: scroll;    
}

.li_checked{
    color: white;
    background-color: darkgrey !important;
    font-weight: bold;
}


.list_selection{
    margin-top: 15px;
    font-size: 8pt;
    color: grey;
}
    .list_selection span{
        margin-left: 8px;
    }

.report_access_list{
    width:35%;
    display:inline-block;
    vertical-align:top;
    font-size: 10pt;
    font-weight:normal;
    padding: 10px 15px;
}

    .report_access_list li{
        cursor: pointer;
    }

    .report_access_list li:hover{
        text-decoration: none;
    }

.report_name, .report_code{
    display: inline-block;
}
.report_name{
    width: 80%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: bottom;
}

.report_code{
    text-align: right;
    font-size: 0.7em;
    font-weight: normal;
    color: #a71414;
}

@media only screen and (max-width: 1024px) {
    .report_access_list{
        width:100%;
    }
}
</style>